import { fromResult } from 'true-myth/toolbelt';

import { alignmentRecordDetailsSchema } from '../alignment-record/store/alignment-record-schema';

import type { ValidatingHttpFetcherWithBaseUrl } from '../../../shared/source/validating-http-fetcher';
import type { AlignmentRecordDetails } from '../alignment-record/store/alignment-record-schema';
import type { LoaderFunction } from 'react-router';
import type Maybe from 'true-myth/maybe';

export type MyAlignmentPageLoaderData = Maybe<AlignmentRecordDetails>;

export const createMyAlignmentPageLoader = (
    validatingCobrainerApiFetcher: ValidatingHttpFetcherWithBaseUrl,
): LoaderFunction => {
    return async () => {
        const alignmentRecordResult = await validatingCobrainerApiFetcher.get(alignmentRecordDetailsSchema, {
            pathname: `/users/me/alignment-records/current`,
        });

        return fromResult(alignmentRecordResult);
    };
};
